import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { IAuthenticationService } from '../interfaces/authentication.abstract.service';
import { IContextService } from '../interfaces/context.abstract.service';
import { IStorageService } from '../interfaces/storage.abstract.service';
import {
    DomainContext, AccountContextValue, HouseholdContextValue,
    GroupContextValue, ClientContextValue, IbdOffIpContextValue,
    AdvisorContextValue, UserContext, SecurityContextValue
} from '../models/context.model';
import { PershingError } from '../models/pershing-error.model';
import { LogService } from './log.service';
import { CoreConstants } from '../constants/core-constants';

@Injectable()
export class ContextService implements IContextService {
    selectedDomainContext$: Observable<DomainContext<any>>;
    selectedOrgContext$: Observable<DomainContext<any>>;
    error$: Observable<PershingError>;

    protected _selectedDomainContext: BehaviorSubject<DomainContext<any>>;
    protected _selectedOrgContext: BehaviorSubject<DomainContext<any>>;
    protected _contextError: BehaviorSubject<PershingError>;

    private deviceType: string;
    private routeContext: any;
    private userContext: any;
    private dataStore: {
        selectedDomainContext: DomainContext<any>;
        selectedOrgContext: DomainContext<any>;
        selectedQuoteType: string;
    };
    hasError = false;
    defaultContext: DomainContext<any> = {
        domain: null,
        value: null
    };

    constructor(private authService: IAuthenticationService, private logService: LogService,
                private storageService: IStorageService) {
        this._contextError = new BehaviorSubject<PershingError>(null);
        this.error$ = this._contextError.asObservable();
        this.loadLocalStorage();
    }

    // populating the values of dataStore-context domain from local Storage.
    loadLocalStorage(): void {
        /*
        This is a workaround for DASF login. Setting the user to be logged in during refresh activity to
        retain the current application context.
        */
        let userSessionValue = this.storageService.getItem('userSession');
        if (userSessionValue !== null && userSessionValue !== undefined) {
            userSessionValue = JSON.parse(this.storageService.getItem('userSession'));
            if (userSessionValue) {
                this.authService.setUserLoggedIn();
            }
            this.storageService.removeItem('userSession');
        }
        // fetching dataStore from LocalStorage.
        const localStorageValue = this.storageService.getItem('dataStore');
        if (localStorageValue !== null && localStorageValue !== undefined) {
            this.storageService.removeItem('dataStore');
            this.dataStore = (JSON.parse(localStorageValue));
            // Emits the context domain from localStorage
            if (this.dataStore.selectedDomainContext && this.dataStore.selectedDomainContext !== null) {
                this._selectedDomainContext = new BehaviorSubject(this.dataStore.selectedDomainContext);
                this.selectedDomainContext$ = this._selectedDomainContext.asObservable();
                const domainContext: any = this.dataStore.selectedDomainContext.domain;
                // if (domainContext === CoreConstants.ACCOUNT) {
                //     let accountContextValue: any = this.dataStore.selectedDomainContext.value;
                //     let domainValue: AccountContextValue = new AccountContextValue(accountContextValue.accountNumber,
                //          accountContextValue.shortName, accountContextValue.ibd, accountContextValue.off, accountContextValue.ip,
                //          accountContextValue.categoryCode, accountContextValue.accountType, accountContextValue.status,
                //          accountContextValue.custodianCode, accountContextValue.businessPurposeCode,
                //          accountContextValue.internalIdentifier, accountContextValue.isInternalCustody);
                //    accountContextValue.isInternalCustody, accountContextValue.accessCategoryCd);
                //     this.setDomainContext(domainContext, domainValue);
                // } else if (domainContext === CoreConstants.GROUP) {
                //     let groupContextValue: any = this.dataStore.selectedDomainContext.value;
                //     // let domainValue: GroupContextValue = new GroupContextValue(groupContextValue.groupId,
                //      groupContextValue.groupDescription, groupContextValue.groupSourceCode, groupContextValue.numberOfAccounts,
                //      groupContextValue.groupType, groupContextValue.accessType, groupContextValue.albridgeIndicator,
                //      groupContextValue.internalIdentifier, groupContextValue.brokerId, groupContextValue.groupCreatorId,
                //     //     groupContextValue.groupGUID);
                //     this.setDomainContext(domainContext, groupContextValue);
                // } else if (domainContext === CoreConstants.HOUSEHOLD) {
                //     let householdContextValue: any = this.dataStore.selectedDomainContext.value;
                //     let domainValue: HouseholdContextValue = new HouseholdContextValue(householdContextValue.groupId,
                //          householdContextValue.groupDescription, householdContextValue.groupSourceCode,
                //          householdContextValue.numberOfAccounts, householdContextValue.groupType, householdContextValue.accessType,
                //      householdContextValue.albridgeIndicator, householdContextValue.internalIdentifier, householdContextValue.brokerId,
                //            householdContextValue.groupCreatorId, householdContextValue.groupGUID);
                //     this.setDomainContext(domainContext, householdContextValue);
                // } else if (domainContext === CoreConstants.CLIENT) {
                //     let clientContextValue: any = this.dataStore.selectedDomainContext.value;
                //     let domainValue: ClientContextValue = new ClientContextValue(clientContextValue.clientId,
                //      clientContextValue.clientName, clientContextValue.status, clientContextValue.ibd, clientContextValue.off,
                //      clientContextValue.ip, clientContextValue.internalIdentifier, clientContextValue.affiliateClientId);
                //     this.setDomainContext(domainContext, clientContextValue);
                // } else if (domainContext === CoreConstants.IBD || domainContext === CoreConstants.OFF ||
                //                  domainContext === CoreConstants.IP) {
                //     let ibdOffIpContextValue: any = this.dataStore.selectedDomainContext.value;
                //     //let domainValue: IbdOffIpContextValue = new IbdOffIpContextValue(ibdOffIpContextValue.ibd,
                //     //     ibdOffIpContextValue.off, ibdOffIpContextValue.ip,
                //     //     ibdOffIpContextValue.ibdName, ibdOffIpContextValue.ipName);
                //     this.setDomainContext(domainContext, ibdOffIpContextValue);
                // }
                if (domainContext === CoreConstants.ACCOUNT || domainContext === CoreConstants.GROUP
                    || domainContext === CoreConstants.HOUSEHOLD || domainContext === CoreConstants.CLIENT || domainContext === CoreConstants.SECURITY
                    || domainContext === CoreConstants.IBD || domainContext === CoreConstants.OFF || domainContext === CoreConstants.IP) {
                    this.setDomainContext(domainContext, this.dataStore.selectedDomainContext.value);
                } else {
                    this.dataStore.selectedDomainContext = null;
                    this._selectedDomainContext = new BehaviorSubject<DomainContext<any>>(this.defaultContext);
                    this.selectedDomainContext$ = this._selectedDomainContext.asObservable();
                }
            } else {
                this.dataStore.selectedDomainContext = null;
                this._selectedDomainContext = new BehaviorSubject<DomainContext<any>>(this.defaultContext);
                this.selectedDomainContext$ = this._selectedDomainContext.asObservable();
            }
            if (this.dataStore.selectedOrgContext && this.dataStore.selectedOrgContext !== null) {
                this._selectedOrgContext = new BehaviorSubject(this.dataStore.selectedOrgContext);
                this.selectedOrgContext$ = this._selectedOrgContext.asObservable();
                const orgContext: any = this.dataStore.selectedOrgContext.domain;
                // org-context
                if (orgContext === CoreConstants.ADVISOR) {
                    const advisorContextValue: any = this.dataStore.selectedOrgContext.value;
                    const domainValue: AdvisorContextValue = new AdvisorContextValue(advisorContextValue.advisorId,
                        advisorContextValue.advisorName,
                        advisorContextValue.roleCode,
                        advisorContextValue.businessParty);
                    this.setOrgDomainContext(orgContext, domainValue);
                }
            } else {
                this.dataStore.selectedOrgContext = null;
                this._selectedOrgContext = new BehaviorSubject<DomainContext<any>>(this.defaultContext);
                this.selectedOrgContext$ = this._selectedOrgContext.asObservable();
            }
        } else {
            this.dataStore = {
                selectedDomainContext: null,
                selectedOrgContext: null,
                selectedQuoteType: null
            };
            // Emits the default context domain -- account
            this._selectedDomainContext = new BehaviorSubject<DomainContext<any>>(this.defaultContext);
            this.selectedDomainContext$ = this._selectedDomainContext.asObservable();

            this._selectedOrgContext = new BehaviorSubject<DomainContext<any>>(this.defaultContext);
            this.selectedOrgContext$ = this._selectedOrgContext.asObservable();
        }
    }

    // saves the selected context domain to local Storage.
    saveLocalStorage(): void {
        if (this.dataStore && this.dataStore.selectedDomainContext) {
            if (this.dataStore && this.dataStore.selectedDomainContext.domain !== null &&
                this.dataStore.selectedDomainContext.domain !== undefined && this.dataStore.selectedDomainContext.value !== null &&
                this.dataStore.selectedDomainContext.value !== undefined) {
                this.storageService.setItem('dataStore', JSON.stringify(this.dataStore));
                // saves the userSession (whether the user is logged in or not) in Local Storage
                const userSession: boolean = this.authService.isLoggedIn();
                this.storageService.setItem('userSession', JSON.stringify(userSession));
            }
        }

        if (this.dataStore && this.dataStore.selectedOrgContext) {
            if (this.dataStore && this.dataStore.selectedOrgContext.domain !== null &&
                this.dataStore.selectedOrgContext.domain !== undefined && this.dataStore.selectedOrgContext.value !== null &&
                this.dataStore.selectedOrgContext.value !== undefined) {
                this.storageService.setItem('dataStore', JSON.stringify(this.dataStore));
                // saves the userSession (whether the user is logged in or not) in Local Storage
                const userSession: boolean = this.authService.isLoggedIn();
                this.storageService.setItem('userSession', JSON.stringify(userSession));
            }
        }
    }

    /**
     * Domain Context is the IWM application domain context (i.e. Account, Household/Group, Client, etc)
     */
    setDomainContext(domain: string, value: any): void {
        // if (this.isAuthenticated()) {
        const domainContext = this.createDomainContext(domain, value);
        this.dataStore.selectedDomainContext = domainContext;
        this._selectedDomainContext.next(Object.assign({}, this.dataStore).selectedDomainContext);
        // }
    }

    /**
     * Org Context is the Organizational domain context (i.e. Advisor etc)
     */
    setOrgDomainContext(domain: string, value: any): void {
        // if (this.isAuthenticated()) {
        const domainContext = this.createOrgDomainContext(domain, value);
        this.dataStore.selectedOrgContext = domainContext;
        this._selectedOrgContext.next(Object.assign({}, this.dataStore).selectedOrgContext);
        // }
    }

    createOrgDomainContext(domain: string, value: any): DomainContext<any> {
        let orgDomainContext: DomainContext<any> = this.defaultContext;

        if (domain === CoreConstants.ADVISOR) {
            orgDomainContext = this.createAdvisorContext(value);
        } else if (domain === CoreConstants.IBDOFFIP) { // Set IBD-OFF-IP in OrgContext to support Lists page components
            orgDomainContext = this.createIbdOffIpContext(domain, value);
        }

        return orgDomainContext;
    }

    clearContext(): void {
        // Reset everything to its default
        this._selectedDomainContext.next(this.defaultContext);
        this.dataStore.selectedDomainContext = null;
    }

    /*
    * This method will iterate the paramsMap and
    * populates if the attribute is defined in target object
    */
    populateObjectAttributes(source, target) {

        const result = target;
        Object.keys(source).map((key) => {
            if (target.hasOwnProperty(key)) {
                result[key] = source[key];
            }
        });
        return result;
    }

    /*
    * This method creates the domain context objects by setting the attributs.
    */
    createDomainContext(domain: string, value: any): DomainContext<any> {
        let domainContext: DomainContext<any> = this.defaultContext;

        if (domain === CoreConstants.ACCOUNT) {
            const prevDomainContext: DomainContext<any> = this.dataStore.selectedDomainContext;
            if (value instanceof Object && !(value instanceof AccountContextValue)) {
                value = this.populateObjectAttributes(value, new AccountContextValue(undefined));
            }
            /*
                Update the domain context value only if the incoming value is a different one.
                This helps when the source component passes limited fields due to which the already
                established context attributes are removed.

                If a domaincontext is already available in context service, then check if it is of type Account and 
                if the account number is same in which case, reuse the domaincontext instead of overwriting it.

                If the domaincontext is not already available or of different account number or or different type, 
                then create a new domain context for the passed account context.
            */
           if (prevDomainContext && prevDomainContext.domain && prevDomainContext.domain === CoreConstants.ACCOUNT &&
			        prevDomainContext.value && value && prevDomainContext.value.accountNumber === value.accountNumber ) {
                if (prevDomainContext.value && prevDomainContext.value instanceof Object && !(prevDomainContext.value instanceof AccountContextValue)) {
                    prevDomainContext.value = Object.assign(new AccountContextValue(undefined), prevDomainContext.value);
                }
		        domainContext = prevDomainContext;
            } else {
	            domainContext = this.createAccountContext(value);
            }
        }

        if (domain === CoreConstants.CLIENT) {
            if (value instanceof Object && !(value instanceof ClientContextValue)) {
                value = this.populateObjectAttributes(value, new ClientContextValue(undefined));
            }
            domainContext = this.createClientContext(value);
        }

        if (domain === CoreConstants.GROUP) {
            if (value instanceof Object && !(value instanceof GroupContextValue)) {
                value = this.populateObjectAttributes(value, new GroupContextValue(undefined));
                if (value.groupGUID === undefined) {
                    value.groupGUID = value.groupCreatorId + '_' + value.groupId + '_' + value.groupSourceCode;
                }
            }
            domainContext = this.createGroupContext(value);
        }

        if (domain === CoreConstants.HOUSEHOLD) {
            if (value instanceof Object && !(value instanceof HouseholdContextValue)) {
                value = this.populateObjectAttributes(value, new HouseholdContextValue(undefined));
                if (value.groupGUID === undefined) {
                    value.groupGUID = value.groupCreatorId + '_' + value.groupId + '_' + value.groupSourceCode;
                }
            }
            domainContext = this.createHouseholdContext(value);
        }

        if (domain === CoreConstants.IBD || domain === CoreConstants.OFF
            || domain === CoreConstants.IP || domain === CoreConstants.IBDOFFIP) {
            if (value instanceof Object && !(value instanceof IbdOffIpContextValue)) {
                value = this.populateObjectAttributes(value, new IbdOffIpContextValue(undefined, undefined, undefined));
                if (value.ibdOffIp === undefined || isNaN(value.ibdOffIp)) {
                    value.ibdOffIp = value.ibd + value.off + value.ip;
                }
            }
            domainContext = this.createIbdOffIpContext(domain, value);
        }

        if (domain === CoreConstants.SECURITY) {
            if (value instanceof Object && !(value instanceof SecurityContextValue)) {
                value = this.populateObjectAttributes(value, new SecurityContextValue(undefined));
            }
            domainContext = this.createSecurityContext(value);
        }

        return domainContext;
    }

    createAccountContext(value: any): DomainContext<AccountContextValue> {
        if (value.accountNumber === undefined && value.length >= 9) {
            return { domain: CoreConstants.ACCOUNT, value: new AccountContextValue(value) };
        } else if (value.accountNumber && value.accountNumber.length >= 9) {
            return { domain: CoreConstants.ACCOUNT, value:  value as AccountContextValue };
        } else {
            this.logService.error(new Error('Account number must be atleast 9 digits'));
            this.setContextError('Account number must be atleast 9 digits');
            return this.defaultContext;
        }
    }

    createGroupContext(value: any): DomainContext<GroupContextValue> {
        if (value.groupGUID === undefined) {
            return { domain: CoreConstants.GROUP,
                value: new GroupContextValue(null, null, null, null, null, null, null, null, null, null, value) };
        } else {
            return { domain: CoreConstants.GROUP, value:  value as GroupContextValue };
        }
    }

    createHouseholdContext(value: any): DomainContext<HouseholdContextValue> {
        if (value.groupId === undefined) {
            return { domain: CoreConstants.HOUSEHOLD, value: new HouseholdContextValue(value) };
        } else {
            return { domain: CoreConstants.HOUSEHOLD, value:  value as HouseholdContextValue };
        }
    }

    createClientContext(value: any): DomainContext<ClientContextValue> {
        if (value.clientId === undefined) {
            return { domain: CoreConstants.CLIENT, value: new ClientContextValue(value) };
        } else {
            return { domain: CoreConstants.CLIENT, value:  value as ClientContextValue };
        }
    }

    createIbdOffIpContext(domain: string, value: any): DomainContext<IbdOffIpContextValue> {
        return { domain, value:  value as IbdOffIpContextValue };
    }

    createAdvisorContext(value: any): DomainContext<AdvisorContextValue> {
        if (value.advisorId === undefined) {
            return { domain: CoreConstants.ADVISOR, value: new AdvisorContextValue(value) };
        } else {
            return { domain: CoreConstants.ADVISOR, value:  value as AdvisorContextValue };
        }
    }

    createSecurityContext(value: any): DomainContext<SecurityContextValue> {
        if (value.symbol === undefined) {
            return { domain: CoreConstants.SECURITY, value: new SecurityContextValue(value) };
        } else {
            return { domain: CoreConstants.SECURITY, value:  value as SecurityContextValue };
        }
    }

    setContextError(errorMessage: string, errorCode?: string) {
        this.hasError = true;
        this._contextError.next(new PershingError(errorMessage, 'ContextService', errorCode));
    }

    clearContextError() {
        this.hasError = false;
        this._contextError.next(null);
    }

    isAuthenticated(): boolean {
        if (this.authService.isLoggedIn()) {
            this.clearContextError();
            return true;
        } else {
            this.setContextError('User not logged in');
            return false;
        }
    }

    getDeviceType(): any {
        return this.deviceType;
    }

    setDeviceType(deviceType: string) {
        this.deviceType = deviceType;
    }
    /** The  setGotoContext and  getGotoContext method will be  deprecated
     *   in subsequent release
     *   instead use  setRouteContext and  getRouteContext
     */
    setRouteContext(routeContext: any) {
        this.routeContext = routeContext;
    }

    getRouteContext(): any {
        return this.routeContext;
    }

    /** @deprecated use setRouteContext instead */
    setGotoContext(goToContext: any) {
        this.logService.warn('setGotoContext method will be deprecated in subsequent release');
        this.setRouteContext(goToContext);
    }

    /** @deprecated use getRouteContext instead */
    getGotoContext(): any {
        this.logService.warn('getGotoContext method will be deprecated in subsequent release');
        return this.getRouteContext();
    }

    setUserContext(userContext: UserContext) {
        if (userContext instanceof Object && !(userContext instanceof UserContext)) {
            userContext = this.populateObjectAttributes(userContext, new UserContext());
        }
        // set brokerTypeCd for to be used in legacy apps
        if (userContext != null && userContext.brokerType != null) {
            const BROKER_TYPE_MAP: any = { PERSHING_INTERNAL_USER : { code: 'BO', legacyCode : 'PERSHING' },
                                          ONE_IBD: { code: 'NR', legacyCode: 'IBD' },
                                          MORE_THAN_TWO_IBDS : { code: 'HV', legacyCode: 'IBD' } };
            const brokerTypeObj: any = BROKER_TYPE_MAP[userContext.brokerType];
            if (brokerTypeObj) {
                userContext.brokerTypeCode = brokerTypeObj.code;
                userContext.brokerTypeLegacy = brokerTypeObj.legacyCode;
            }
        }
        this.userContext = userContext;
    }

    getUserContext(): UserContext {
        return this.userContext;
    }
}
